import { Observable, Subject, Subscription } from 'rxjs/Rx'
import { ITimer, TimerService } from '..'

const INTERVAL = 1000

export class Countup implements ITimer {

  public timeOut: Observable<void> = new Subject<void>()

  public get elapsedTime(): number {
    return this._timer.elapsedTime
  }

  public get timeUpdate(): Observable<void> {
    return this._timeUpdate
  }

  public get currentTime(): number {
    return this._timer.elapsedTime
  }

  private _timeUpdate: Subject<void> = new Subject<void>()
  private _timerSubscription: Subscription

  constructor(
    private _timer: TimerService
  ) { }

  public start() {
    this._timer.start()
    this._timerSubscription = Observable.timer(INTERVAL, INTERVAL).subscribe(() => {
      this._timer.tick()
      this._timeUpdate.next()
    })
  }

  public pause() {
    this._timerSubscription && this._timerSubscription.unsubscribe()
    this._timer.pause()
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/core/services/timers/countup/countup.ts